// ============================================================
// Wholesale RFQ v4 -- Shea Butter Market
// ============================================================

// --- STATE ---------------------------------------------------
var Q = {};
var rowScents = {};

var _category    = 'all';
var _scentsOnly  = false;
var _sortBy      = 'default';
var _searchTerm  = '';
var _searchDebounce = null;
var _origOrder   = new WeakMap();
var _searchIndex = {};
var _scrollY     = 0;

// --- SCROLL LOCK (iOS-compatible) ----------------------------
// iOS Safari ignores overflow:hidden on body.
// Fix: position:fixed + saved scrollY, then restore on unlock.

function _lockScroll() {
  _scrollY = window.scrollY;
  document.body.style.overflow = 'hidden';
  document.body.style.position = 'fixed';
  document.body.style.top      = '-' + _scrollY + 'px';
  document.body.style.width    = '100%';
}

function _unlockScroll() {
  document.body.style.overflow = '';
  document.body.style.position = '';
  document.body.style.top      = '';
  document.body.style.width    = '';
  window.scrollTo(0, _scrollY);
}

// --- HELPERS -------------------------------------------------

function fm(n) {
  return '$' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

function getQty(key) {
  var el = document.getElementById('qty-' + key);
  return el ? Math.max(1, parseInt(el.value) || 1) : 1;
}

function rowNode(key) {
  return document.getElementById('row-' + key);
}

function rowData(key) {
  var r = rowNode(key);
  if (!r) return null;
  var hasScents = r.dataset.hasScents === 'true';
  var scentEl   = document.getElementById('scent-' + key);
  var scent     = hasScents && scentEl ? scentEl.value : '';
  return {
    key       : key,
    scent     : scent,
    product   : r.dataset.product,
    variant   : r.dataset.variant,
    sku       : r.dataset.sku,
    price     : parseFloat(r.dataset.price),
    priceFmt  : r.dataset.priceFmt,
    moq       : parseInt(r.dataset.moq) || 1,
    hasScents : hasScents
  };
}

function updateCostCell(key) {
  var el  = document.getElementById('cost-'  + key);
  var mel = document.getElementById('mcost-' + key);
  var r   = rowNode(key);
  if (!r) return;
  var val = fm(getQty(key) * parseFloat(r.dataset.price));
  if (el)  el.textContent  = val;
  if (mel) mel.textContent = val;
}

// --- SEARCH INDEX --------------------------------------------
// Built once at DOMContentLoaded. Searches: name, category,
// SKU, ingredient chips, description + INCI from hidden divs.

function _buildSearchIndex() {
  var rows = document.querySelectorAll('.wfq-tbl tbody tr');
  rows.forEach(function(row) {
    var key  = row.id.replace('row-', '');
    var det  = document.getElementById('det-' + key);
    var parts = [
      row.dataset.product || '',
      row.dataset.variant || '',
      row.dataset.cat     || '',
      row.dataset.sku     || ''
    ];
    row.querySelectorAll('.ki-chip').forEach(function(c) {
      parts.push(c.textContent);
    });
    if (det) {
      ['d-desc', 'd-ing', 'd-scents'].forEach(function(cls) {
        var el = det.querySelector('.' + cls);
        if (el) parts.push(el.textContent);
      });
    }
    _searchIndex[row.id] = parts.join(' ').toLowerCase();
  });
}

// --- SEARCH --------------------------------------------------

function handleSearch(val) {
  clearTimeout(_searchDebounce);
  _searchDebounce = setTimeout(function() {
    _searchTerm = val.toLowerCase().trim();
    var clearBtn = document.getElementById('searchClear');
    if (clearBtn) clearBtn.style.display = _searchTerm ? 'flex' : 'none';
    _applyAll();
    _updateSearchFeedback();
  }, 180);
}

function clearSearch() {
  var inp = document.getElementById('searchInput');
  if (inp) { inp.value = ''; inp.focus(); }
  var clearBtn = document.getElementById('searchClear');
  if (clearBtn) clearBtn.style.display = 'none';
  _searchTerm = '';
  _applyAll();
  _updateSearchFeedback();
}

function _updateSearchFeedback() {
  var fb = document.getElementById('searchFeedback');
  if (!fb) return;
  if (!_searchTerm) { fb.textContent = ''; return; }
  var visible = document.querySelectorAll('.wfq-tbl tbody tr:not([style*="display: none"])').length;
  // Also count rows with no inline style (default visible)
  var total = 0;
  document.querySelectorAll('.wfq-tbl tbody tr').forEach(function(r) {
    if (r.style.display !== 'none') total++;
  });
  fb.textContent = total === 0
    ? 'No products found — try different keywords'
    : total + ' product' + (total !== 1 ? 's' : '') + ' found';
}

// --- QTY CONTROLS --------------------------------------------

function chQty(key, delta) {
  var el  = document.getElementById('qty-' + key);
  if (!el) return;
  var moq = parseInt(el.min) || 1;
  el.value = Math.max(moq, (parseInt(el.value) || moq) + delta);
  updateCostCell(key);
}

document.addEventListener('input', function(e) {
  if (!e.target.classList.contains('qty-input')) return;
  var key = e.target.id.replace('qty-', '');
  updateCostCell(key);
  var q = Q[key];
  if (q && !q.hasScents) {
    q.qty = Math.max(q.moq, parseInt(e.target.value) || q.moq);
    renderPanel();
  }
});

// --- ADD / REMOVE --------------------------------------------

function addToQuote(key) {
  var data = rowData(key);
  if (!data) return;
  var qty = getQty(key);

  if (data.hasScents) {
    var qkey = key + '__' + (data.scent || 'none').replace(/\s+/g, '_');
    if (Q[qkey]) {
      Q[qkey].qty = qty;
    } else {
      Q[qkey] = {
        key: data.key, scent: data.scent, product: data.product,
        variant: data.variant, sku: data.sku, price: data.price,
        priceFmt: data.priceFmt, moq: data.moq, hasScents: data.hasScents,
        qkey: qkey, qty: qty
      };
      rowScents[key] = (rowScents[key] || 0) + 1;
    }
    updateScentBadge(key);
    var rn = rowNode(key);
    if (rn) rn.classList.add('scented-added');
  } else {
    if (Q[key]) {
      Q[key].qty = qty;
    } else {
      Q[key] = {
        key: data.key, scent: data.scent, product: data.product,
        variant: data.variant, sku: data.sku, price: data.price,
        priceFmt: data.priceFmt, moq: data.moq, hasScents: data.hasScents,
        qkey: key, qty: qty
      };
      markRowAdded(key, true);
    }
  }
  renderPanel();
  if (!panelOpen()) openPanel();
}

function removeFromQ(qkey) {
  var item = Q[qkey];
  if (!item) return;
  delete Q[qkey];
  if (item.hasScents) {
    rowScents[item.key] = Math.max(0, (rowScents[item.key] || 1) - 1);
    updateScentBadge(item.key);
    if ((rowScents[item.key] || 0) === 0) {
      var rn = rowNode(item.key);
      if (rn) rn.classList.remove('scented-added');
    }
  } else {
    markRowAdded(item.key, false);
  }
  renderPanel();
}

function clearAll() {
  Object.keys(Q).forEach(function(qkey) {
    var item = Q[qkey];
    if (item.hasScents) {
      rowScents[item.key] = 0;
      updateScentBadge(item.key);
      var rn = rowNode(item.key);
      if (rn) rn.classList.remove('scented-added');
    } else {
      markRowAdded(item.key, false);
    }
  });
  Object.keys(Q).forEach(function(k) { delete Q[k]; });
  renderPanel();
}

function markRowAdded(key, on) {
  var row = rowNode(key);
  var btn = document.getElementById('btn-' + key);
  if (!row || !btn) return;
  btn.classList.toggle('added', on);
  btn.querySelector('.bl').textContent = on ? 'In Quote \u2713' : 'Add';
}

function updateScentBadge(key) {
  var el = document.getElementById('scent-badge-' + key);
  if (!el) return;
  var n = rowScents[key] || 0;
  el.textContent = n > 0 ? (n + ' scent' + (n > 1 ? 's' : '') + ' added') : '';
}

// --- PANEL ---------------------------------------------------

function renderPanel() {
  var items   = Object.keys(Q).map(function(k) { return Q[k]; });
  var bodyEl  = document.getElementById('qpBody');
  var emptyEl = document.getElementById('qpEmpty');

  ['qpN', 'qbtCount'].forEach(function(id) {
    var el = document.getElementById(id);
    if (el) el.textContent = items.length;
  });

  var reqBtn = document.getElementById('reqBtn');
  if (reqBtn) reqBtn.disabled = items.length === 0;

  var mCount = document.getElementById('mqbCount');
  var mTotal = document.getElementById('mqbTotal');

  // Remove existing item nodes, keep emptyEl
  Array.from(bodyEl.children).forEach(function(c) {
    if (c !== emptyEl) c.remove();
  });

  if (items.length === 0) {
    emptyEl.style.display = 'block';
    document.getElementById('qpTotal').textContent = '$0.00';
    document.getElementById('qpLines').textContent = '0';
    document.getElementById('qpUnits').textContent = '0';
    if (mCount) mCount.textContent = '0 items';
    if (mTotal) mTotal.textContent = '$0.00';
    return;
  }
  emptyEl.style.display = 'none';

  var total = 0, units = 0;
  items.forEach(function(item) {
    total += item.price * item.qty;
    units += item.qty;
    var varLine   = item.variant ? item.variant : '';
    var scentLine = (item.scent && item.hasScents) ? item.scent : '';
    var d = document.createElement('div');
    d.className = 'qp-item';
    d.innerHTML =
      '<div class="qp-i-info">' +
        '<div class="qp-i-name">' + item.product + '</div>' +
        (varLine   ? '<div class="qp-i-meta">'  + varLine   + '</div>' : '') +
        (scentLine ? '<div class="qp-i-scent">\u2B25 ' + scentLine + '</div>' : '') +
        '<div class="qp-i-price">' + item.priceFmt + ' \u00d7 ' + item.qty + ' = ' + fm(item.price * item.qty) + '</div>' +
      '</div>' +
      '<div class="qp-i-right">' +
        '<div class="qp-qty">' +
          '<button class="qp-qb" onclick="pChQty(\'' + item.qkey + '\',-1)" type="button">\u2212</button>' +
          '<span class="qp-qv">' + item.qty + '</span>' +
          '<button class="qp-qb" onclick="pChQty(\'' + item.qkey + '\',1)" type="button">+</button>' +
        '</div>' +
        '<button class="qp-rm" onclick="removeFromQ(\'' + item.qkey + '\')" type="button">Remove</button>' +
      '</div>';
    bodyEl.appendChild(d);
  });

  var totalFmt = fm(total);
  document.getElementById('qpTotal').textContent = totalFmt;
  document.getElementById('qpLines').textContent = items.length;
  document.getElementById('qpUnits').textContent = units;
  if (mCount) mCount.textContent = items.length + ' item' + (items.length !== 1 ? 's' : '');
  if (mTotal) mTotal.textContent = totalFmt;
}

function pChQty(qkey, delta) {
  if (!Q[qkey]) return;
  Q[qkey].qty = Math.max(Q[qkey].moq, Q[qkey].qty + delta);
  if (!Q[qkey].hasScents) {
    var el = document.getElementById('qty-' + Q[qkey].key);
    if (el) { el.value = Q[qkey].qty; updateCostCell(Q[qkey].key); }
  }
  renderPanel();
}

// --- PANEL OPEN / CLOSE --------------------------------------

function panelOpen() {
  return document.getElementById('qPanel').classList.contains('open');
}
function openPanel() {
  document.getElementById('qPanel').classList.add('open');
  document.getElementById('wfqOuter').classList.add('panel-open');
}
function closePanel() {
  document.getElementById('qPanel').classList.remove('open');
  document.getElementById('wfqOuter').classList.remove('panel-open');
}
function togglePanel() {
  panelOpen() ? closePanel() : openPanel();
}

// --- DETAILS MODAL -------------------------------------------

function showDetails(detId) {
  var src = document.getElementById(detId);
  if (!src) return;

  var titleEl = src.querySelector('.d-title');
  var subEl   = src.querySelector('.d-sub');
  var descEl  = src.querySelector('.d-desc');
  var ingEl   = src.querySelector('.d-ing');
  var scentsEl= src.querySelector('.d-scents');
  var shelfEl = src.querySelector('.d-shelf');
  var carSrc  = src.querySelector('.d-carousel');

  var title  = titleEl  ? titleEl.textContent  : '';
  var sub    = subEl    ? subEl.textContent    : '';
  var desc   = descEl   ? descEl.innerHTML     : '';
  var ing    = ingEl    ? ingEl.textContent    : '';
  var scents = scentsEl ? scentsEl.textContent : '';
  var shelf  = shelfEl  ? shelfEl.textContent  : '';

  // Set title (first text node)
  var h3 = document.getElementById('detTitle');
  if (h3) h3.firstChild.textContent = title;
  var subOut = document.getElementById('detSub');
  if (subOut) subOut.textContent = sub;

  function showEl(wrapId, elId, html, asText) {
    var wrap = document.getElementById(wrapId);
    var el   = document.getElementById(elId);
    if (!wrap) return;
    if (html && html.trim()) {
      if (el) { if (asText) el.textContent = html; else el.innerHTML = html; }
      wrap.style.display = '';
    } else {
      wrap.style.display = 'none';
    }
  }

  showEl('detDescWrap', 'detDesc', desc, false);
  showEl('detIngWrap',  'detIng',  ing,  true);

  // Ingredient carousel
  var carWrap = document.getElementById('detCarouselWrap');
  var carEl   = document.getElementById('detCarousel');
  var carHTML = carSrc ? carSrc.innerHTML.trim() : '';
  if (carHTML) {
    carEl.innerHTML = carHTML;
    carWrap.style.display = '';
    var firstChip = carEl.querySelector('.ingredient-chip');
    if (firstChip) {
      carEl.querySelectorAll('.ingredient-chip').forEach(function(ch) {
        ch.classList.remove('active');
      });
      firstChip.classList.add('active');
    }
  } else {
    carWrap.style.display = 'none';
  }

  // Scents
  var scWrap = document.getElementById('detScentsWrap');
  var scEl   = document.getElementById('detScents');
  if (scents && scents.trim()) {
    scEl.innerHTML = scents.split(',').map(function(s) {
      return '<span class="det-chip">' + s.trim() + '</span>';
    }).join('');
    scWrap.style.display = '';
  } else {
    scWrap.style.display = 'none';
  }

  // Meta (shelf life)
  var metaEl = document.getElementById('detMeta');
  if (metaEl) {
    metaEl.innerHTML = shelf && shelf.trim()
      ? '<div class="det-meta-item"><strong>Shelf Life</strong><span>' + shelf.trim() + '</span></div>'
      : '';
  }

  // Scroll modal back to top
  var inner = document.getElementById('detModalInner');
  if (inner) inner.scrollTop = 0;

  document.getElementById('detOverlay').classList.add('open');
  _lockScroll();
}

function closeDet() {
  document.getElementById('detOverlay').classList.remove('open');
  _unlockScroll();
}

function scrollToIng(index, button) {
  var wrapper  = button.closest('.ing-carousel-wrapper');
  if (!wrapper) return;
  var carousel = wrapper.querySelector('.ing-carousel');
  var cards    = carousel.querySelectorAll('.ing-card');
  var target   = cards[index];
  if (target) {
    carousel.scrollTo({ left: target.offsetLeft - carousel.offsetLeft, behavior: 'smooth' });
  }
  wrapper.querySelectorAll('.ingredient-chip').forEach(function(ch) {
    ch.classList.remove('active');
  });
  button.classList.add('active');
}

// --- QUOTE MODAL ---------------------------------------------

function openQuoteModal() {
  buildPreview();
  buildPayload();
  document.getElementById('qrOverlay').classList.add('open');
  _lockScroll();
}

function closeQuoteModal() {
  document.getElementById('qrOverlay').classList.remove('open');
  _unlockScroll();
}

function buildPreview() {
  var items = Object.keys(Q).map(function(k) { return Q[k]; });
  var html  = '';
  var total = 0;
  items.forEach(function(item) {
    var sub     = item.price * item.qty;
    total += sub;
    var scent   = (item.scent && item.hasScents) ? ' \u00b7 ' + item.scent : '';
    var variant = item.variant ? ' (' + item.variant + ')' : '';
    html += '<div class="qr-prow"><span>' + item.product + variant + scent + ' \u00d7 ' + item.qty + '</span><span>' + fm(sub) + '</span></div>';
  });
  html += '<div class="qr-ptotal"><span>Estimated Total</span><span>' + fm(total) + '</span></div>';
  document.getElementById('qrPreview').innerHTML = html;
}

function buildPayload() {
  var items = Object.keys(Q).map(function(k) { return Q[k]; });

  function getVal(sel) {
    var el = document.querySelector(sel);
    return el ? el.value : '';
  }

  var phone = getVal('[name="contact[phone]"]');
  var city  = getVal('[name="contact[city]"]');
  var btype = getVal('[name="contact[biz_type]"]');
  var exist = getVal('[name="contact[existing]"]');
  var notes = getVal('[name="contact[notes]"]');

  var body  = '=== WHOLESALE QUOTE REQUEST -- SHEA BUTTER MARKET ===\n\n';
  body += 'PRODUCTS REQUESTED:\n' + new Array(57).join('-') + '\n';
  var total = 0;
  items.forEach(function(item) {
    var sub     = item.price * item.qty;
    total += sub;
    var sku     = item.sku     ? ' [SKU: ' + item.sku + ']' : '';
    var variant = item.variant ? ' (' + item.variant + ')' : '';
    var scent   = (item.scent && item.hasScents) ? ' | Scent: ' + item.scent : '';
    body += '- ' + item.product + variant + sku + scent + '\n';
    body += '  Qty: ' + item.qty + '  x  ' + item.priceFmt + '  =  ' + fm(sub) + '\n';
  });
  body += new Array(57).join('-') + '\n';
  body += 'ESTIMATED TOTAL: ' + fm(total) + ' (Starter tier shown -- final tier applied on invoice)\n\n';
  body += 'CONTACT DETAILS:\n';
  if (phone) body += 'Phone: '         + phone + '\n';
  if (city)  body += 'Location: '      + city  + '\n';
  if (btype) body += 'Business Type: ' + btype + '\n';
  if (exist) body += 'Existing Account: ' + exist + '\n';
  if (notes) body += '\nNotes:\n' + notes + '\n';

  document.getElementById('qPayload').value = body;
}

var rfqForm = document.getElementById('rfqForm');
if (rfqForm) rfqForm.addEventListener('submit', buildPayload);

// --- KEYBOARD ------------------------------------------------

document.addEventListener('keydown', function(e) {
  if (e.key !== 'Escape') return;
  var detOpen = document.getElementById('detOverlay');
  var qrOpen  = document.getElementById('qrOverlay');
  if (detOpen && detOpen.classList.contains('open')) { closeDet(); return; }
  if (qrOpen  && qrOpen.classList.contains('open'))  { closeQuoteModal(); }
});

// --- BACKDROP TOUCH BLOCK ------------------------------------
// Prevents iOS page-scroll bleed when touching the dark backdrop.

function _initOverlayTouchBlock() {
  ['detOverlay', 'qrOverlay'].forEach(function(id) {
    var el = document.getElementById(id);
    if (!el) return;
    el.addEventListener('touchmove', function(e) {
      if (e.target === el) e.preventDefault();
    }, { passive: false });
  });
}

// --- INIT ----------------------------------------------------

window.addEventListener('DOMContentLoaded', function() {
  _buildSearchIndex();
  _saveOrder();
  _applyAll();
  renderPanel();
  _initOverlayTouchBlock();

  if (window.location.search.indexOf('contact_posted=true') !== -1) {
    var fw = document.getElementById('qrFormWrap');
    var qs = document.getElementById('qrSuccess');
    if (fw) fw.style.display = 'none';
    if (qs) qs.style.display = 'block';
    openQuoteModal();
    clearAll();
  }
});

// --- FILTER & SORT -------------------------------------------

function _saveOrder() {
  document.querySelectorAll('.wfq-tbl tbody').forEach(function(tb) {
    if (!_origOrder.has(tb)) {
      _origOrder.set(tb, Array.from(tb.querySelectorAll('tr')).map(function(r) { return r.id; }));
    }
  });
  _updatePillCounts();
}

function _updatePillCounts() {
  var counts = { all: 0 };
  document.querySelectorAll('.wfq-tbl tbody tr').forEach(function(row) {
    counts.all++;
    var cat = row.dataset.cat || '__other__';
    counts[cat] = (counts[cat] || 0) + 1;
  });
  document.querySelectorAll('.filter-pill').forEach(function(pill) {
    var key = pill.dataset.filter;
    var n   = counts[key];
    if (n !== undefined && key !== 'all') {
      pill.textContent = pill.textContent.replace(/ \(\d+\)$/, '') + ' (' + n + ')';
    }
    if (key === 'all') pill.textContent = 'All (' + counts.all + ')';
  });
}

function setCategory(cat) {
  _category = cat;
  document.querySelectorAll('.filter-pill').forEach(function(p) {
    p.classList.toggle('active', p.dataset.filter === cat);
  });
  _applyAll();
}

function setScentsOnly(val) { _scentsOnly = val; _applyAll(); }
function setSort(val)       { _sortBy     = val; _applyAll(); }

function _applyAll() {
  var anyVisible = false;

  document.querySelectorAll('.cat-block').forEach(function(block) {
    var blockType = block.dataset.type || '__other__';
    var tbody     = block.querySelector('tbody');
    if (!tbody) return;

    // Sort
    var rows = Array.from(tbody.querySelectorAll('tr'));
    if (_sortBy !== 'default') {
      rows.sort(function(a, b) {
        if (_sortBy === 'name-asc')   return (a.dataset.product || '').localeCompare(b.dataset.product || '');
        if (_sortBy === 'name-desc')  return (b.dataset.product || '').localeCompare(a.dataset.product || '');
        if (_sortBy === 'price-asc')  return parseFloat(a.dataset.price || 0) - parseFloat(b.dataset.price || 0);
        if (_sortBy === 'price-desc') return parseFloat(b.dataset.price || 0) - parseFloat(a.dataset.price || 0);
        return 0;
      });
    } else {
      var orig = _origOrder.get(tbody);
      if (orig) {
        rows.sort(function(a, b) { return orig.indexOf(a.id) - orig.indexOf(b.id); });
      }
    }
    rows.forEach(function(r) { tbody.appendChild(r); });

    // Filter: category + scents + search (all independent)
    var blockVisible = false;
    rows.forEach(function(row) {
      var rowCat      = row.dataset.cat || '__other__';
      var catMatch    = _category === 'all' || rowCat === _category || blockType === _category;
      var scentMatch  = !_scentsOnly || row.dataset.hasScents === 'true';
      var searchMatch = !_searchTerm || (_searchIndex[row.id] || '').indexOf(_searchTerm) !== -1;
      var show        = catMatch && scentMatch && searchMatch;
      row.style.display = show ? '' : 'none';
      if (show) blockVisible = true;
    });

    block.style.display = blockVisible ? '' : 'none';
    if (blockVisible) anyVisible = true;
  });

  var nr = document.getElementById('noResults');
  if (nr) nr.classList.toggle('show', !anyVisible);
}

// --- CATALOGUE EXPORT ----------------------------------------
// Shared data collector — used by both CSV and PDF exports.

function _collectCatalogueData() {
  var categories  = {};
  var catOrder    = [];
  var seenByTitle = {};

  document.querySelectorAll('.wfq-tbl tbody tr').forEach(function(row) {
    var title = row.dataset.product;
    if (!title || seenByTitle[title]) return;
    seenByTitle[title] = true;

    var cat = row.dataset.cat || 'Other';
    if (!categories[cat]) { categories[cat] = []; catOrder.push(cat); }

    var key    = row.id.replace('row-', '');
    var det    = document.getElementById('det-' + key);
    var price  = parseFloat(row.dataset.price) || 0;
    var msrpEl = row.querySelector('td[data-m="msrp"] .price-msrp');
    var msrp   = msrpEl ? msrpEl.textContent.trim() : '';
    var sizeEl = row.querySelector('.p-size');
    var size   = sizeEl ? sizeEl.textContent.trim() : '';
    var ki = [];
    row.querySelectorAll('.ki-chip').forEach(function(c) { ki.push(c.textContent.trim()); });

    var desc = '', fullIng = '', scents = '', shelf = '';
    if (det) {
      var dDesc  = det.querySelector('.d-desc');
      var dIng   = det.querySelector('.d-ing');
      var dSc    = det.querySelector('.d-scents');
      var dShelf = det.querySelector('.d-shelf');
      if (dDesc)  desc    = dDesc.textContent.trim();
      if (dIng)   fullIng = dIng.textContent.trim();
      if (dSc)    scents  = dSc.textContent.trim();
      if (dShelf) shelf   = dShelf.textContent.trim();
    }

    categories[cat].push({
      title: title, size: size, sku: row.dataset.sku || '',
      moq: row.dataset.moq || '1', price: price, msrp: msrp,
      ki: ki, desc: desc, fullIng: fullIng, scents: scents, shelf: shelf
    });
  });

  return { categories: categories, catOrder: catOrder };
}

// CSV export — instant download, no print dialog, no popup needed.
function exportCatalogueCSV() {
  var data    = _collectCatalogueData();
  var dateStr = new Date().toLocaleDateString('en-CA');
  var esc     = function(v) { return '"' + String(v || '').replace(/"/g, '""') + '"'; };

  var rows = [
    ['SHEA BUTTER MARKET -- WHOLESALE PRODUCT CATALOGUE'],
    ['Generated: ' + dateStr],
    ['Contact: info@sheabuttermarket.com | sheabuttermarket.com/wholesale'],
    [],
    ['Tier', 'Min Order', 'Discount', 'Payment Terms'],
    ['Starter', '$500',    '40% off MSRP', 'Net 15'],
    ['Growth',  '$1,500',  '45% off MSRP', 'Net 30'],
    ['Volume',  '$3,000+', '50% off MSRP', 'Net 45'],
    [],
    ['Category', 'Product', 'Size', 'SKU', 'MSRP', 'Wholesale Price', 'MOQ', 'Key Ingredients', 'Available Scents', 'Shelf Life', 'Description', 'Full Ingredients (INCI)']
  ];

  data.catOrder.forEach(function(cat) {
    data.categories[cat].forEach(function(p) {
      rows.push([
        cat,
        p.title,
        p.size,
        p.sku,
        p.msrp,
        '$' + p.price.toFixed(2),
        p.moq + ' units',
        p.ki.join('; '),
        p.scents,
        p.shelf,
        p.desc,
        p.fullIng
      ]);
    });
  });

  var csv  = rows.map(function(r) { return r.map(esc).join(','); }).join('\r\n');
  var blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8;' });
  var url  = URL.createObjectURL(blob);
  var a    = document.createElement('a');
  a.href = url;
  a.download = 'SBM-Catalogue-' + dateStr + '.csv';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

// PDF export — opens a self-contained window and calls print() there.
// This avoids any body-class manipulation on the main page, which was
// the cause of the infinite-loading bug in the previous approach.
function exportCataloguePDF() {
  var win = window.open('', '_blank', 'width=900,height=700');
  if (!win) {
    alert('Please allow pop-ups for this site to download the catalogue as PDF, then try again.');
    return;
  }

  var data    = _collectCatalogueData();
  var dateStr = new Date().toLocaleDateString('en-CA', { year: 'numeric', month: 'long', day: 'numeric' });

  // Build product HTML (same structure as before)
  var bodyHTML = '';

  // Header
  bodyHTML +=
    '<div class="c-header">' +
      '<div class="c-logo">' +
        '<strong>Shea Butter Market</strong>' +
        '<em>Wholesale Product Catalogue</em>' +
        '<span>Handcrafted on Vancouver Island, BC &middot; Sourced from Kperisi Village, Northern Ghana</span>' +
      '</div>' +
      '<div class="c-meta">' +
        '<span>info@sheabuttermarket.com</span>' +
        '<span>sheabuttermarket.com/wholesale</span>' +
        '<span>' + dateStr + '</span>' +
      '</div>' +
    '</div>';

  // Tier strip
  bodyHTML +=
    '<div class="c-tiers">' +
      '<div class="c-tier"><strong>Starter</strong><span>$500 min &middot; 40% off MSRP &middot; Net 15</span></div>' +
      '<div class="c-tier"><strong>Growth</strong><span>$1,500 min &middot; 45% off MSRP &middot; Net 30</span></div>' +
      '<div class="c-tier"><strong>Volume</strong><span>$3,000+ &middot; 50% off MSRP &middot; Net 45</span></div>' +
      '<div class="c-tier-note">Prices shown at Starter tier. Final tier applied on invoice. First orders: credit card or e-transfer before shipment.</div>' +
    '</div>';

  // Products by category
  data.catOrder.forEach(function(cat) {
    bodyHTML += '<div class="c-cat-block">';
    bodyHTML += '<div class="c-cat-label">' + cat + '</div>';

    data.categories[cat].forEach(function(p) {
      bodyHTML += '<div class="c-product">';

      // Name + price
      bodyHTML +=
        '<div class="c-p-head">' +
          '<div class="c-p-name">' + p.title + '</div>' +
          '<div class="c-p-price">' +
            (p.msrp ? '<span class="c-msrp">MSRP ' + p.msrp + '</span>' : '') +
            '<span class="c-ws">Wholesale ' + fm(p.price) + '</span>' +
          '</div>' +
        '</div>';

      // Specs line
      var specs = [];
      if (p.size) specs.push('<b>Size</b> ' + p.size);
      if (p.sku)  specs.push('<b>SKU</b> '  + p.sku);
      specs.push('<b>MOQ</b> ' + p.moq + ' units');
      bodyHTML += '<div class="c-specs">' + specs.join(' &nbsp;&middot;&nbsp; ') + '</div>';

      // Description
      if (p.desc) bodyHTML += '<div class="c-desc">' + p.desc + '</div>';

      // Key ingredients
      if (p.ki.length) {
        bodyHTML +=
          '<div class="c-row">' +
            '<span class="c-lbl">Key Botanicals</span>' +
            '<span class="c-chips">' +
              p.ki.map(function(k) { return '<span class="c-chip">' + k + '</span>'; }).join('') +
            '</span>' +
          '</div>';
      }

      // Scents
      if (p.scents) bodyHTML += '<div class="c-row"><span class="c-lbl">Scents</span><span>' + p.scents + '</span></div>';

      // Shelf life
      if (p.shelf) bodyHTML += '<div class="c-row"><span class="c-lbl">Shelf Life</span><span>' + p.shelf + '</span></div>';

      // Full INCI
      if (p.fullIng) bodyHTML += '<div class="c-inci"><span class="c-lbl">Ingredients (INCI)</span> ' + p.fullIng + '</div>';

      bodyHTML += '</div>'; // .c-product
    });

    bodyHTML += '</div>'; // .c-cat-block
  });

  // Footer
  bodyHTML +=
    '<div class="c-footer">' +
      '<p>Standard lead time 5&ndash;7 business days. Rush orders (3&ndash;5 days) at +15% surcharge. ' +
      'Free shipping on orders over $1,000 within Canada. Defective goods must be reported within 48 hours of delivery. ' +
      'All products carry an 18-month shelf life unopened.</p>' +
      '<p><strong>To place an order:</strong> info@sheabuttermarket.com &nbsp;&middot;&nbsp; sheabuttermarket.com/wholesale</p>' +
    '</div>';

  // Self-contained HTML document written to the new window.
  // All styles are inlined — no external dependencies.
  var fullHTML = '<!DOCTYPE html>' +
    '<html lang="en">' +
    '<head>' +
      '<meta charset="UTF-8">' +
      '<meta name="viewport" content="width=device-width,initial-scale=1">' +
      '<title>Shea Butter Market &mdash; Wholesale Catalogue</title>' +
      '<style>' +
        '*{box-sizing:border-box;margin:0;padding:0}' +
        'body{font-family:Georgia,"Times New Roman",serif;font-size:11pt;color:#000;background:#fff;padding:20mm 18mm 16mm}' +

        '.c-header{display:flex;justify-content:space-between;align-items:flex-start;padding-bottom:10pt;border-bottom:2pt solid #000;margin-bottom:12pt}' +
        '.c-logo strong{display:block;font-size:18pt;font-weight:700;letter-spacing:-.02em;margin-bottom:3pt;font-family:Georgia,serif}' +
        '.c-logo em{display:block;font-style:italic;font-size:13pt;color:#555;margin-bottom:3pt}' +
        '.c-logo span{display:block;font-size:8pt;color:#888;font-family:Arial,sans-serif}' +
        '.c-meta{text-align:right;font-size:8pt;color:#888;font-family:Arial,sans-serif;display:flex;flex-direction:column;gap:2pt;align-items:flex-end}' +

        '.c-tiers{display:grid;grid-template-columns:1fr 1fr 1fr;gap:0;border:1pt solid #ccc;margin-bottom:14pt;overflow:hidden;border-radius:3pt}' +
        '.c-tier{padding:6pt 12pt;border-right:1pt solid #ccc;background:#fafafa}' +
        '.c-tier:last-of-type{border-right:none}' +
        '.c-tier strong{display:block;font-size:8pt;text-transform:uppercase;letter-spacing:.07em;font-family:Arial,sans-serif;margin-bottom:2pt}' +
        '.c-tier span{font-size:9pt;font-family:Arial,sans-serif}' +
        '.c-tier-note{grid-column:1/-1;padding:5pt 12pt;font-size:7.5pt;color:#888;background:#f2f2f2;border-top:1pt solid #ccc;font-family:Arial,sans-serif}' +

        '.c-cat-label{font-size:8pt;text-transform:uppercase;letter-spacing:.14em;font-weight:700;font-family:Arial,sans-serif;color:#fff;background:#1a1a1a;padding:4pt 10pt;margin:12pt 0 0}' +

        '.c-product{padding:9pt 0;border-bottom:.5pt solid #ddd;page-break-inside:avoid}' +
        '.c-product:last-child{border-bottom:none}' +

        '.c-p-head{display:flex;justify-content:space-between;align-items:baseline;gap:8pt;margin-bottom:3pt}' +
        '.c-p-name{font-size:13pt;font-weight:700;font-family:Georgia,serif}' +
        '.c-p-price{display:flex;gap:8pt;align-items:baseline;flex-shrink:0;font-family:Arial,sans-serif}' +
        '.c-msrp{font-size:9pt;color:#aaa;text-decoration:line-through}' +
        '.c-ws{font-size:11pt;font-weight:700}' +

        '.c-specs{font-size:8.5pt;color:#555;margin-bottom:5pt;font-family:Arial,sans-serif}' +
        '.c-specs b{color:#000;font-weight:700}' +

        '.c-desc{font-size:9.5pt;line-height:1.6;color:#333;margin-bottom:5pt;font-family:Arial,sans-serif}' +

        '.c-row{display:flex;gap:6pt;font-size:8.5pt;margin-bottom:3pt;align-items:flex-start;font-family:Arial,sans-serif}' +
        '.c-lbl{font-size:7.5pt;text-transform:uppercase;letter-spacing:.07em;font-weight:700;color:#aaa;flex-shrink:0;min-width:80pt;padding-top:1pt;font-family:Arial,sans-serif}' +
        '.c-chips{display:flex;flex-wrap:wrap;gap:3pt}' +
        '.c-chip{font-size:8pt;border:.5pt solid #ccc;padding:2pt 7pt;background:#f8f8f8;font-family:Arial,sans-serif}' +

        '.c-inci{font-size:7.5pt;color:#999;margin-top:4pt;line-height:1.5;font-family:Arial,sans-serif}' +
        '.c-inci .c-lbl{display:inline;min-width:auto;margin-right:4pt}' +

        '.c-footer{margin-top:16pt;padding-top:8pt;border-top:.5pt solid #ddd;font-size:7.5pt;color:#888;font-family:Arial,sans-serif;line-height:1.6}' +
        '.c-footer p{margin-bottom:3pt}' +

        '@media print{' +
          'body{padding:0}' +
          '@page{margin:14mm 16mm;size:A4 portrait}' +
          '.c-cat-label{page-break-after:avoid}' +
          '.c-product{page-break-inside:avoid}' +
        '}' +
      '</style>' +
    '</head>' +
    '<body>' + bodyHTML + '</body>' +
    '</html>';

  win.document.write(fullHTML);
  win.document.close();

  // Trigger print once the new window has fully rendered.
  // The onload event fires after document.close() in most browsers.
  win.onload = function() { win.print(); };
  // Belt-and-suspenders fallback for browsers that fire onload before close.
  setTimeout(function() {
    try { if (win && !win.closed) win.print(); } catch (e) {}
  }, 600);
}

// --- PRINT QUOTE ---------------------------------------------

function printQuote() {
  var items = Object.keys(Q).map(function(k) { return Q[k]; });
  if (!items.length) { alert('Add items to your quote before printing.'); return; }

  var dateStr = new Date().toLocaleDateString('en-CA', { year: 'numeric', month: 'long', day: 'numeric' });
  var dateEl  = document.getElementById('wpDate');
  if (dateEl) dateEl.textContent = dateStr;

  var tbody = '', total = 0;
  items.forEach(function(item) {
    var sub  = item.price * item.qty;
    total += sub;
    var meta = [item.variant, item.hasScents ? item.scent : ''].filter(Boolean).join(' \u00b7 ');
    tbody +=
      '<tr>' +
        '<td><strong>' + item.product + '</strong></td>' +
        '<td>' + (meta || '\u2014') + '</td>' +
        '<td style="font-family:monospace;font-size:9pt">' + (item.sku || '\u2014') + '</td>' +
        '<td class="wp-r">' + item.priceFmt + '</td>' +
        '<td class="wp-r">' + item.qty + '</td>' +
        '<td class="wp-r"><strong>$' + sub.toFixed(2) + '</strong></td>' +
      '</tr>';
  });

  var bodyEl  = document.getElementById('wpTableBody');
  var totalEl = document.getElementById('wpTotal');
  if (bodyEl)  bodyEl.innerHTML = tbody;
  if (totalEl) totalEl.textContent = '$' + total.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  document.body.classList.remove('print-catalogue');
  window.print();
}

// --- CSV DOWNLOAD --------------------------------------------

function downloadCSV() {
  var items = Object.keys(Q).map(function(k) { return Q[k]; });
  if (!items.length) { alert('Add items to your quote before downloading.'); return; }

  var esc     = function(v) { return '"' + String(v).replace(/"/g, '""') + '"'; };
  var dateStr = new Date().toLocaleDateString('en-CA');

  var rows = [
    ['SHEA BUTTER MARKET -- WHOLESALE QUOTE'],
    ['Generated: ' + dateStr],
    ['Contact: info@sheabuttermarket.com'],
    [],
    ['Product', 'Variant', 'Scent', 'SKU', 'Unit Price (Starter 40% off)', 'Quantity', 'Line Total']
  ];

  var total = 0;
  items.forEach(function(item) {
    var sub = item.price * item.qty;
    total += sub;
    rows.push([
      item.product,
      item.variant || '',
      (item.hasScents ? item.scent : '') || '',
      item.sku || '',
      item.priceFmt,
      item.qty,
      '$' + sub.toFixed(2)
    ]);
  });

  rows.push([]);
  rows.push(['', '', '', '', '', 'ESTIMATED TOTAL', '$' + total.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')]);
  rows.push([]);
  rows.push(['PRICING TIERS']);
  rows.push(['Starter', '$500 min',    '40% off MSRP', 'Net 15']);
  rows.push(['Growth',  '$1,500 min',  '45% off MSRP', 'Net 30']);
  rows.push(['Volume',  '$3,000+ min', '50% off MSRP', 'Net 45']);

  var csv  = rows.map(function(r) { return r.map(esc).join(','); }).join('\r\n');
  var blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8;' });
  var url  = URL.createObjectURL(blob);
  var a    = document.createElement('a');
  a.href     = url;
  a.download = 'SBM-Quote-' + dateStr + '.csv';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}